// ── freeLimits.js — 무료 플랜 사용 제한 (V29) ─────────────────────────────
//
// 무료 사용자 한도:
//  - 영수증 OCR: 월 20장
//  - 거래장부: 월 100건
//
// 프로 플랜은 무제한.
//
// 카운트는 클라이언트에서 transactions 컬렉션 기반으로 계산.
// (PMF 전 단계라 우회 가능하지만 명시적 안내 + 업그레이드 유도 목적엔 충분)

export const FREE_LIMITS = {
  ocrPerMonth: 20,
  transactionsPerMonth: 100,
};

// 이번 달 YYYY-MM
export function getMonthKey(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

// 이번 달 거래 카운트 (모든 source)
export function countMonthlyTransactions(transactions, monthKey = getMonthKey()) {
  return (transactions || []).filter(t => String(t?.date || '').startsWith(monthKey)).length;
}

// 이번 달 OCR로 생성된 거래 카운트
export function countMonthlyOcr(transactions, monthKey = getMonthKey()) {
  return (transactions || []).filter(t => {
    if (!String(t?.date || '').startsWith(monthKey)) return false;
    return t?.source === 'ocr';
  }).length;
}

// 거래장부 한도 초과 여부 (추가 N건 가정)
export function isOverTransactionLimit(transactions, plan = 'free', additional = 1) {
  if (plan !== 'free') return false;
  return countMonthlyTransactions(transactions) + additional > FREE_LIMITS.transactionsPerMonth;
}

// OCR 한도 초과 여부 (추가 N장 가정)
export function isOverOcrLimit(transactions, plan = 'free', additional = 1) {
  if (plan !== 'free') return false;
  return countMonthlyOcr(transactions) + additional > FREE_LIMITS.ocrPerMonth;
}

// 남은 한도 (UI 표시용)
export function getRemainingOcr(transactions, plan = 'free') {
  if (plan !== 'free') return Infinity;
  return Math.max(0, FREE_LIMITS.ocrPerMonth - countMonthlyOcr(transactions));
}

export function getRemainingTransactions(transactions, plan = 'free') {
  if (plan !== 'free') return Infinity;
  return Math.max(0, FREE_LIMITS.transactionsPerMonth - countMonthlyTransactions(transactions));
}

// 사용자에게 보여줄 메시지
export function ocrLimitMessage(transactions, plan = 'free') {
  if (plan !== 'free') return '';
  const used = countMonthlyOcr(transactions);
  const remaining = Math.max(0, FREE_LIMITS.ocrPerMonth - used);
  if (remaining === 0) {
    return `이번 달 영수증 OCR 한도(${FREE_LIMITS.ocrPerMonth}장)를 다 썼어요. 프로 플랜으로 업그레이드하면 무제한 사용 가능합니다.`;
  }
  return `이번 달 OCR ${used}/${FREE_LIMITS.ocrPerMonth}장 사용 (남은 ${remaining}장)`;
}

export function txnLimitMessage(transactions, plan = 'free') {
  if (plan !== 'free') return '';
  const used = countMonthlyTransactions(transactions);
  const remaining = Math.max(0, FREE_LIMITS.transactionsPerMonth - used);
  if (remaining === 0) {
    return `이번 달 거래 입력 한도(${FREE_LIMITS.transactionsPerMonth}건)를 다 썼어요. 프로 플랜으로 업그레이드하면 무제한 사용 가능합니다.`;
  }
  return `이번 달 거래 ${used}/${FREE_LIMITS.transactionsPerMonth}건 사용 (남은 ${remaining}건)`;
}
